import { z } from 'zod';
/** Affected-person categories for AI impact classification. */
export const AFFECTED_PERSONS = [
    'workers', 'job_applicants', 'patients', 'students', 'consumers',
    'justice_system_participants', 'migrants_asylum_seekers',
    'law_enforcement_subjects', 'children', 'vulnerable_groups',
    'general_public',
    // V112-2-9 (owner PD-2, 2026-10-21): the intake's own categories for consequential decisions on lending /
    // insurance and housing (Colorado SB 26-189), no longer folded into `consumers`.
    'borrowers', 'tenants',
];
export const affectedPersonSchema = z.array(z.enum(AFFECTED_PERSONS)).default([]);
export const AFFECTED_PERSON_LABELS = {
    workers: 'Workers',
    job_applicants: 'Job Applicants',
    patients: 'Patients',
    students: 'Students',
    consumers: 'Consumers',
    justice_system_participants: 'Justice System Participants',
    migrants_asylum_seekers: 'Migrants & Asylum Seekers',
    law_enforcement_subjects: 'Law Enforcement Subjects',
    children: 'Children',
    vulnerable_groups: 'Vulnerable Groups',
    general_public: 'General Public',
    borrowers: 'Borrowers & Insurance Applicants',
    tenants: 'Tenants & Housing Applicants',
};
//# sourceMappingURL=affected-persons.js.map